'use client';

import { type ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '@alltrails/denali/components/Link';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';

export type ShowMoreLinksProps = {
  linkItems: SeoLinkItem[];
  collapsedLimit: number;
  isBot?: boolean;
  children: (visibleLinkItems: SeoLinkItem[], showMoreSlot: ReactNode | null, isExpanded: boolean) => ReactNode;
};

export default function ShowMoreLinks({ linkItems, collapsedLimit, isBot = false, children }: ShowMoreLinksProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasMoreItems = linkItems.length > collapsedLimit;
  const showLimitedExperience = hasMoreItems && !isBot;
  const displayItems = isExpanded || !showLimitedExperience ? linkItems : linkItems.slice(0, collapsedLimit);

  const showMoreSlot = showLimitedExperience ? (
    <Link onClick={() => setIsExpanded(!isExpanded)} size="sm" variant="secondary">
      {isExpanded ? <FormattedMessage defaultMessage="Show less" /> : <FormattedMessage defaultMessage="Show more" />}
    </Link>
  ) : null;

  return <>{children(displayItems, showMoreSlot, isExpanded)}</>;
}
